import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { OpenDialogAddEditResourceComponent } from 'app/components/dialog/open-dialog-add-edit-resource/open-dialog-add-edit-resource.component';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-admin-resource',
  templateUrl: './admin-resource.component.html',
  styleUrls: ['./admin-resource.component.scss']
})
export class AdminResourceComponent implements OnInit {

  searchForm: UntypedFormGroup;
  valueInput: string;
  userConnected: any;
  clubCode: any;
  title: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private authService: AuthService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataService.valueFilterResource$.next(filterValue);
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  addOrEditResource(action: string, resource?: any): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditResourceComponent, {
      data: { action, resource },
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.dataService.clubActiveResources$.next(res.data);
        this.dataService.updatedParameters$.next(true);
      }
    });
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

    const title = {
      admin: `Liste des ressources du club : ${this.clubCode}`,
      club: `Liste des ressources de mon club`
    };

    this.title = title[this.userConnected.role];
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }
}
